import { render } from "./PengumumanPemenang.vue?vue&type=template&id=d62abe04&scoped=true"
import script from "./PengumumanPemenang.vue?vue&type=script&lang=js"
export * from "./PengumumanPemenang.vue?vue&type=script&lang=js"

import "./PengumumanPemenang.vue?vue&type=style&index=0&id=d62abe04&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d62abe04"]])

export default __exports__